import { saveToLocalStorage, fetchFromLocalStorage, removeFromLocalStorage } from '../utils/browserStorage'

export default {
  saveToLocalStorage,
  fetchFromLocalStorage,
  removeFromLocalStorage
}
